import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getCategory, getProductsByCategory } from '../mock/mock';
import ProductCard from '../components/ProductCard';

const CategoryPage = () => {
  const { slug } = useParams();
  const category = getCategory(slug);
  const products = getProductsByCategory(slug);

  if (!category) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <h1 className="font-anton text-4xl ps-blue-text mb-4">Category not found</h1>
        <Link to="/products" className="ps-blue-bg text-white px-6 py-3 rounded-full font-oswald uppercase btn-press">Back to products</Link>
      </div>
    );
  }

  return (
    <div>
      <div className="relative h-64 overflow-hidden">
        <img src={category.image} alt={category.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 ps-blue-bg opacity-70" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          {category.isNew && <span className="ps-yellow-bg text-black text-xs font-bold px-3 py-1 rounded-full font-oswald uppercase mb-3">New Category</span>}
          <h1 className="hero-outline text-5xl sm:text-6xl">{category.name}</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <Link to="/products" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#1a1ad6] font-oswald uppercase text-sm mb-8"><ArrowLeft size={16} /> All Products</Link>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;
